import {
  Label as HeadlessLabel,
  type LabelProps as HeadlessLabelProps,
} from "@headlessui/react";
import { classNames } from "../../utils/classNames";

interface ILabelProps extends HeadlessLabelProps {
  className?: string;
  component?: "headless" | "html";
}

export function Label({
  className,
  component = "headless",
  ...props
}: ILabelProps) {
  const LabelComponent = component === "headless" ? HeadlessLabel : "label";

  return (
    <LabelComponent
      {...props}
      data-slot="label"
      className={classNames(
        "select-none text-sm/5 text-primary data-[disabled]:opacity-50",
        className,
      )}
    >
      {props.children as React.ReactNode}
    </LabelComponent>
  );
}
